// Distributors domain
export const GET_USER_TENANTS_ENDPOINT = 'user/distributors';

// Events domain
export const GET_EVENTS_COUNT_ENDPOINT = 'events/count';
export const GET_EVENTS_LAST_ENDPOINT = 'events/lastEvent';
export const GET_EVENTS_DISABLED_ENDPOINT = 'events/disable';
export const GET_EVENTS_ENDPOINT = 'events';
export const GET_EVENTS_MAP_VIEW_ENDPOINT = 'events/mapView';
export const GET_EVENTS_CENTER_MAP_VIEW_ENDPOINT =
  'events/{{centerId}}/mapView';

// Alarms domain
export const GET_ALARMS_COUNT_ENDPOINT = 'alarms/count';
export const GET_ALARMS_ENDPOINT = 'alarms';
export const GET_ALARMS_DISABLED_ENDPOINT = 'alarms/disable';
export const GET_ALARMS_MAP_VIEW_ENDPOINT = 'alarms/mapView';
export const GET_ALARMS_CENTER_MAP_VIEW_ENDPOINT =
  'alarms/{{centerId}}/mapView';

// Center's domains
export const GET_INFRAESTRUCTURE_ENDPOINT = 'centers/{{centerId}}/transformers';
export const GET_CENTER_DETAILS_ENDPOINT = 'centers/{{centerId}}';

// Rsabt's domains
export const RSABTS_ENDPOINT = 'rsabts';
export const RSBATS_ALARMS_DISABLE_ENDPOINT = 'rsabts/alarms/disable';
export const GET_RSABTS_MAP_VIEW_ENDPOINT = 'rsabts/mapView';
export const GET_RSABTS_CENTER_MAP_VIEW_ENDPOINT =
  'rsabts/{{centerId}}/mapView';
export const GET_RSABTS_MAX_INTENSITY_ENDPOINT = 'rsabts/max-intensity';
export const GET_RSABTS_MAX_TEMPERATURE_ENDPOINT = 'rsabts/max-temperature';
export const GET_LAST_SNAPSHOT_ENDPOINT =
  'centers/{{centerId}}/rsabts/{{rsabtId}}/lastSnapshot';
export const GET_RSABT_CHART_ENDPOINT =
  'centers/{{centerId}}/rsabts/{{rsabtId}}/chart';
export const GET_RSABT_STATS_ENDPOINT =
  'centers/{{centerId}}/rsabts/{{rsabtId}}/stats';
export const GET_RSABT_HARMONICS_ENDPOINT =
  'centers/{{centerId}}/rsabts/{{rsabtId}}/harmonics';
export const GET_RSABT_HARMONIC_STATS_ENDPOINT =
  'centers/{{centerId}}/rsabts/{{rsabtId}}/stats/harmonics/{{harmonicId}}';
export const GET_RSABT_RANKING_ENDPOINT = 'rsabts/ranking-capacity-transformer';

// Tsabt's domains
export const GET_TSABT_RANKING_ENDPOINT = 'rsabts/ranking-capacity-line-phase';
export const GET_TSBAT_CHART_ENDPOINT =
  'centers/{{centerId}}/tsabts/{{tsabtId}}/chart';
export const GET_TSABT_STATS_ENDPOINT =
  'centers/{{centerId}}/tsabts/{{tsabtId}}/stats';
export const GET_TSABTS_STATS_ENDPOINT = 'centers/{{centerId}}/tsabts/stats';

// VTN's domain
export const GET_VTN_LAST_SNAPSHOT_ENDPOINT =
  'centers/{{centerId}}/vtns/{{vtnId}}/lastSnapshot';
export const GET_VTN_CHART_ENDPOINT =
  'centers/{{centerId}}/vtns/{{vtnId}}/chart';

// Administration's domains
export const GET_CENTERS_ENDPOINT = 'centers/list';
export const GET_TRAFOS_ENDPOINT = 'centers/list/transformers';
export const GET_LINES_CENTERS_ENDPOINT = 'centers/list/lines';
export const GET_LINES_ENDPOINT = 'lines';
export const GET_CONFIG_CENTER_ENDPOINT = 'alarms/config/list';
export const GET_CONFIG_CENTER_FILTER_ENDPOINT = 'alarms/config';
export const GET_DATA_CONFIG_DISTRIBUTOR_ENDPOINT = 'alarms/config/default';
export const DISABLE_SAVED_CONFIG_ENDPOINT = 'alarms/config/disable';
export const ENABLE_SAVED_CONFIG_ENDPOINT = 'alarms/config/enable';

// Losses
export const GET_LOSSES_ENDPOINT = 'losses';
export const GET_LOSSES_AVERAGE_ENDPOINT = 'losses/average';
export const GET_LOSSES_LOCATION_ENDPOINT = 'losses/by-location';
export const GET_LOSSES_CHART_ENDPOINT = 'losses/chart';
export const GET_LOSSES_STATS_ENDPOINT = 'losses/stats';
export const GET_LOSSES_CENTER_ENDPOINT = 'centers/{{centerId}}/losses/stats';

// Remote Configuration domain
export const GET_LT_BOX_ENDPOINT = 'lt_box/{{distributorId}}';
export const GET_LT_BOX_CONFIG_ENDPOINT =
  'lt_box/{{distributorId}}/{{lvPanelId}}';
export const UPDATE_LT_BOX_CONFIG_ENDPOINT =
  'lt_box/{{distributorId}}/{{centerId}}';

// HTTP Headers
/**
 * Header name used to pass error context information to HTTP interceptors.
 * This allows interceptors to display context-appropriate error messages.
 */
export const ERROR_CONTEXT_HEADER = 'X-Error-Context';

// Error Context Values
/**
 * Error context value for administration-related operations.
 * Used to display appropriate error titles when administration operations fail.
 */
export const ERROR_CONTEXT_ADMINISTRATION =
  'NOTIFICATIONS.ADMINISTRATION.TITLE';

/**
 * Error context value for alarms-related operations.
 * Used to display appropriate error titles when alarms operations fail.
 */
export const ERROR_CONTEXT_ALARMS = 'NOTIFICATIONS.ALARMS.TITLE';

/**
 * Error context value for events-related operations.
 * Used to display appropriate error titles when events operations fail.
 */
export const ERROR_CONTEXT_EVENTS = 'NOTIFICATIONS.EVENTS.TITLE';
